import { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import "../../styles/menu.css"
import logo from "../../assets/logo-inmobiliaria.jpeg"
import { menuArray } from "./menu-data"
import { useApp } from "../../context/useApp"
import { BsList, BsX } from "react-icons/bs"

function Menu() {
  let location = useLocation()
  const [path, svPath] = useState()
  const { user, logoutUser, menuOpen, toggleMenu, setMenuClosed } = useApp()
  const [loadData, setLoadData] = useState(true)
  const [links, setLinks] = useState([])

  useEffect(() => {
    if (loadData) {
      setLoadData(false)
      if (user.userType === "Administrador") {
        setLinks(menuArray)
      } else {
        let newLinks = []
        for (let index = 0; index < menuArray.length; index++) {
          if (menuArray[index].privileges === 1) {
            newLinks.push(menuArray[index])
          }
        }
        setLinks(newLinks)
      }
    }
    //console.log(links);
  }, [loadData, links, user.userType])

  useEffect(() => {
    svPath(location.pathname)
    setMenuClosed() // Cerrar el menú cuando cambia la ruta
  }, [location, setMenuClosed])

  return (
    <>
      {/* Botón hamburguesa - visible en todos los dispositivos */}
      <button className="hamburger-btn" onClick={() => toggleMenu()}>
        {menuOpen ? <BsX size={24} /> : <BsList size={24} />}
      </button>

      {/* Overlay para cerrar el menú */}
      {menuOpen && (
        <div className="menu-overlay" onClick={() => setMenuClosed()}></div>
      )}

      {/* Contenedor del menú */}
      <div
        className={`h-100 menu-primary-container p-3 d-flex flex-column ${menuOpen ? "menu-open" : ""}`}
      >
        <div className="d-flex flex-column align-items-center justify-content-center mt-4">
          <div>
            <img alt={"logo"} src={logo} className="logo-img" />
          </div>
          <span className="mt-5 user-info-text name">
            Hola,{" "}
            <b>
              {user.firstName} {user.lastName}
            </b>
          </span>
          <span className="user-info-text">{user.userType}</span>
        </div>
        <div className="d-flex flex-column my-auto">
          {links.map((link, index) => (
            <div key={index} className="d-flex flex-column list-content">
              <Link
                to={link.link}
                className={path === "/" + link.link ? "tag active" : "tag"}
              >
                {link.tag}
              </Link>
              {link.data.map((sublink, subindex) => (
                <Link
                  key={"sub" + subindex}
                  to={sublink.link}
                  className={
                    path === "/" + sublink.link ? "sublink active" : "sublink"
                  }
                >
                  {sublink.title}
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="logout-button" onClick={logoutUser}>
            <i className="user-info-text">
              <b>Cerrar Sesión</b>
            </i>
          </div>
          <span className="user-info-text">
            <i>CasApp, 2026</i>
          </span>
        </div>
      </div>
    </>
  )
}

export default Menu
